// utils/axios.ts
import axios from 'axios';
import { AxiosRequestConfig } from 'axios';
import { decrypt } from './encryption';
import { toast } from './toast';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4020',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para requests
api.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const encryptedToken = localStorage.getItem('token');
    if (encryptedToken) {
      try {
        const token = decrypt(encryptedToken);
        if (!config.headers) {
          config.headers = {};
        }
        config.headers.Authorization = `Bearer ${token}`;
      } catch (error) {
        console.error('Error al desencriptar el token:', error);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para respuestas
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          toast.error('Sesión expirada. Por favor, inicie sesión nuevamente.');
          // Redirigir tras un instante para que el toast sea visible
          setTimeout(() => { window.location.href = '/login'; }, 1200);
          break;
        case 403:
          toast.error('No tiene permisos para realizar esta acción.');
          break;
        case 409:
          // Manejo específico para conflictos (registros duplicados)
          break;
        default:
          // Otros errores serán manejados por los servicios individuales
          break;
      }
    }
    return Promise.reject(error);
  }
);

export default api;